import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ShortResponseDto, UserAlertReportCompanyIdsDto } from '../../dto';
import { BaseApiService } from './base-api.service';

@Injectable({
    providedIn: 'root',
})
export class NewsAutomationsApiService {
    private readonly url: string = 'service/contactcloud/newsAutomations';

    constructor(private readonly baseApiService: BaseApiService) {
    }

    getUserAlertReports(reportId: string): Observable<UserAlertReportCompanyIdsDto> {
        return this.baseApiService.get<UserAlertReportCompanyIdsDto>(`${this.url}/userAlertReports/companyIds`, { params: { reportId }});
    }

    deleteBounceEmail(email: string): Observable<ShortResponseDto<string>> {
        return this.baseApiService.get<ShortResponseDto<string>>(`${this.url}/userAlertEmail/deleteBounceEmail`, { params: { email } });
    }

    checkWaitingToValidateUserEmail(): Observable<ShortResponseDto<boolean>> {
        return this.baseApiService.get<ShortResponseDto<boolean>>(`${this.url}/userAlertEmail/waitingToValidateUserEmail`);
    }
}
